import { getNewLandingPageTypes } from './types';

const initialState = {
  isLoading: false,
  error: '',
  data: {},
};

const newLandingPageReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case getNewLandingPageTypes.REQUEST: {
      return { ...state, isLoading: true, error: '', data: {} };
    }

    case getNewLandingPageTypes.SUCCESS: {
      return {
        ...state,
        data: {
          ...payload,
          programTypes:
            payload.programTypes &&
            payload.programTypes.length &&
            payload.programTypes.sort((a, b) => a.title.localeCompare(b.title)),
        },
        isLoading: false,
      };
    }

    case getNewLandingPageTypes.FAILED: {
      return { ...state, error: payload, isLoading: false };
    }

    default:
      return state;
  }
};

export default newLandingPageReducer;
